import * as actions from './productionOutsource/actions'
import * as mutations from './productionOutsource/mutations'
import * as getters from './productionOutsource/getters'

import { dataProps } from './productionOutsource/properties'

const state = {
    list: [],
    props: JSON.parse(JSON.stringify(dataProps)),
    nav: {
        page_number: 1, 
        had_results: false,
        limit: 10,
        total: 0,
        sort_column_name: 't1.id',
        sort_direction: 1, search_term: '', 
        search_term_array: []
    }   
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/productionOutsource.js